import { ActionType, getType } from 'typesafe-actions';

import * as config from '../../actionCreators/config';

export default function (
  state: MerchantConfig = {},
  action: ActionType<typeof config>,
): MerchantConfig {
  switch (action.type) {
    case getType(config.setMerchantConfig): {
      const { value } = action.payload;
      return { ...state, ...value };
    }
    default:
      return state;
  }
}
